"use client";

import type { FC } from "react";
import { truncateText } from "@huub-web/utils";

import { Text, type TextProps } from "../Text/Text";

export type TruncatedTextProps = Omit<TextProps, "elipsis" | "children"> & {
  value: string;
  maxSize: number;
  asText?: boolean;
};

/**
 * Truncate text if it exceeds the max character size.
 */
export const TruncatedText: FC<TruncatedTextProps> = ({
  value: text,
  maxSize,
  asText = true,
  ...props
}) => {
  if (text.length <= maxSize) {
    return <Text {...props}>{text}</Text>;
  }

  const truncatedText = truncateText(text, maxSize);

  return asText ? (
    <Text noWrap {...props}>
      {truncatedText}
    </Text>
  ) : (
    truncatedText
  );
};
